import firebase from 'firebase/compat/app';
import "firebase/compat/auth";
import "firebase/compat/firestore";
import "firebase/compat/storage";

const firebaseConfig = {
    apiKey: "AIzaSyDJ4cp6oeidJ0BQkf3a-jroNzLiDYUya0M",
    authDomain: "venezuela-stats.firebaseapp.com",
    projectId: "venezuela-stats",
    storageBucket: "venezuela-stats.appspot.com",
    messagingSenderId: "836022641063",
    appId: "1:836022641063:web:2cd6aa1060f3fe6c95d682"
  };

firebase.initializeApp(firebaseConfig);

export const fb = firebase;
export const db = firebase.firestore();
export const auth = firebase.auth();
export const storage = firebase.storage();